import React from 'react';
import { Outlet } from 'react-router-dom';
import { IdvContextProvider } from '../../context/index.js';
import { LabelContextProvider } from '../../context/LabelContext.js';
const IdvRoute = ({ idvVariables }) => (React.createElement(IdvContextProvider, { idvVariables: idvVariables },
    React.createElement(LabelContextProvider, { brand: idvVariables.state.brand },
        React.createElement(Outlet, null))));
export default IdvRoute;
//# sourceMappingURL=index.js.map